module.exports = __webpack_public_path__ + "static/media/SusanAvatar.0cf27d2e.png";